<template>
  <div
    class="mx-auto h-screen overflow-y-scroll "
    v-bind:class="{ down: isScrollingDown }"
    id="container"
    v-on:scroll="handleScroll"
  >
    <Intro class="min-h-screen"  />
  <ParallaxGallery class="z-0 w-full min-h-screen absolute top-0 left-0"  v-if="showParallax" />
    
    <Print class="min-h-sc_reen" />
    <Donate class="min-h-sc_reen" />
    <Draw class="min-h-screesn p-0" :isTouch="isTouch" />
    <Gallery class="min-h-scr_een p-4 md:p-10 bg-pink-100" :hearts="hearts" />
    <section class="flex justify-center my-12">
      <Spinner class="" v-if="!limitReached" />
    </section>
    <Footer class="" />

    <GalleryDetail
      v-if="showModal"
      class="modal-route"
      :id="this.$route.params.id"
      show="true"
    >
    </GalleryDetail>

    <!-- <div
      id="backtotop"
      class="fixed right-10 bottom-10 z-50"
      v-scroll-to="'#intro'"
    >
    </div> -->
  </div>
</template>

<script>
import Intro from "@/components/Intro.vue";
import Footer from "@/components/Footer.vue";
import Print from "@/components/Print.vue";
import Donate from "@/components/Donate.vue";
import Draw from "@/components/Draw.vue";
import Hearts from "@/components/Hearts.vue";
import Gallery from "@/components/Gallery.vue";
import Spinner from "@/components/Spinner.vue";
import ParallaxGallery from "@/components/ParallaxGallery.vue";
import GalleryDetail from "@/components/GalleryDetail.vue";
import Axios from "axios";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: "Home",
  // props:['showModal'],
  watch: {
    $route: {
      immediate: true,
      handler: function(newVal, oldVal) {
        this.showModal = newVal.meta && newVal.meta.showModal;
        this.$forceUpdate();
      },
    },
  },
  components: {
    Intro,
    Print,
    Footer,
    Donate,
    Draw,
    // Hearts,
    Gallery,
    Spinner,
    GalleryDetail,
    // ParallaxGallery,
    // Parallax
  },
  data() {
    return {
      // id:,
      index: false,
      galleryObj: {},
      isTouch: false,
      showModal: false,
      showParallax:false,
      lastscroll: 0,
      isScrollingDown: false,
      hearts: [],
      offset: 0,
      page: 1,
      limit: 100,
      limitReached: false,
      bottomOfPage: false,
      bottomThreshold: 200,
      fetching: false,
      showSpinner: true,
      showDraw: true,
      positions: [],
      speeds:[-65,-100,-75,-85]
    };
  },
  computed: {
    apiURL() {
      return (
        "https://api.caseyhouse.com/sendyourlove/items/hearts?fields=id,rank,artist,anonymous,image.private_hash,image.width,image.height&limit=" +
        this.limit +
        "&page=" +
        this.page +
        "&sort=+sort"
      );
    },
  },
  methods: {
    is_touch_device() {
      if ("ontouchstart" in window || window.TouchEvent) return true;

      if (window.DocumentTouch && document instanceof DocumentTouch)
        return true;

      const prefixes = ["", "-webkit-", "-moz-", "-o-", "-ms-"];
      const queries = prefixes.map((prefix) => `(${prefix}touch-enabled)`);

      return window.matchMedia(queries.join(",")).matches;
    },

    findPosition(id) {
      var i;
      for (i = 0; i < this.hearts.length; i++) {
        if (this.hearts[i].id == id) {
          return i;
        }
      }
      return false;
    },
    position() {},
    handleScroll: function() {
      // eslint-disable-next-line
      this.bottomOfPage =
        this.$el.scrollTop + window.innerHeight >=
        this.$el.scrollHeight - this.bottomThreshold;

      if (this.bottomOfPage && !this.fetching && !this.limitReached) {
        this.fetching = true;
        this.page++;

        Axios.get(this.apiURL).then((response) => {
          if (response.data.data.length) {
            this.hearts = this.hearts.concat(response.data.data);
            this.fetching = false;
          } else {
            this.limitReached = true;
          }
        });
      }

      this.isScrollingDown = this.$el.scrollTop >= this.lastscroll;
      this.lastscroll = this.$el.scrollTop;
    },

    scrollAnimation() {
      // gsap.to("#intro", {
      //   yPercent: +100,
      //   ease: "none",
      //   // opacity: 0,
      //   autoAlpha:0,
      //   scrollTrigger: {
      //     scroller: "#container",
      //     trigger: "#parallax",
      //     start: 100,
      //     pinSpacing: false,
      //     markers: false,
      //     endTrigger: "#print",
      //     scrub: true,
      //   },
      // });

      // gsap.to("#parallax", {
      //   yPercent: -100,
      //   ease: "none",
      //   // autoAlpha:1,
      //   // opacity: 0,
      //   scrollTrigger: {
      //     scroller: "#container",
      //     trigger: "#parallax",
      //     start: "center bottom",
      //     pinSpacing: true,
      //     markers: true,
      //     endTrigger: "#print",
      //     scrub: true,
      //   },
      // });



    },
  },
  mounted() {


    Axios.get(this.apiURL).then(
      (response) => (this.hearts = response.data.data)
    );
    // for (let index = 0; index < array.length; index++) {
    //   const element = array[index];

    // }
    this.scrollAnimation();
  },
};
</script>

<style scoped>
/* #container{
  scroll-snap-type: y proximity;
} */

#container section#print,
#container section#draw {
  scroll-snap-align: start;
}
#intro{
  /* margin-bottom:75vh; */
}
#parallax{
  margin-top:75vh;
}


</style>
